import {Injectable} from '@angular/core';
import {DcpEntryGroup} from '@dcp/configurator';
import {UntilDestroy} from '@ngneat/until-destroy';
import {OrderEntry} from '@spartacus/cart/base/root/models/cart.model';
import {EntryGroupService} from '../../../product/services/entry-group.service';
import {EddlAdobeTrackingDataProductData} from './models/eddl-adobe-tracking-data';

@UntilDestroy()
@Injectable({
  providedIn: 'root'
})

export class DcpEddlCartStateService {

  constructor(
    protected entryGroupService: EntryGroupService) {
  }

  getRelevantCpsGroups(entryGroups: DcpEntryGroup[], productCode: string): DcpEntryGroup[] {
    const relevantRootEntryGroups = this.entryGroupService.getRootGroupsByProductCode(entryGroups, productCode);
    return relevantRootEntryGroups.reduce((acc, rootEntryGroup) => [
      ...acc,
      ...this.entryGroupService.filter(
        rootEntryGroup.entryGroups,
        (entryGroup) => !this.entryGroupService.isProduct(entryGroup)
      )
    ], []);
  }


  getRelevantCartEntries(entries: OrderEntry[]): OrderEntry[] {
    return entries?.filter((entry: OrderEntry) => !(!entry.product || !entry.totalPrice || Object.keys(entry.product).includes('configuratorType')));
  }

  getProductTrackingData(entry: OrderEntry): EddlAdobeTrackingDataProductData {
    if (!entry) {
      return;
    }

    const product: EddlAdobeTrackingDataProductData = {
      id: entry.product?.supplierAlternativeAID?.toString(),
      name: entry.product?.name,
      quantity: entry.quantity?.toString(),
      price: entry.totalPrice?.value?.toString(),
    };
    // Products are only assigned to one category. They can belong to multiple industries but not categories (DCP-20673).
    if (entry.product?.categories && entry.product.categories[0]?.name) {
      product.category = entry.product.categories[0].name;
    }
    if (entry.product?.vendor?.name) {
      product.partnerName = entry.product.vendor.name;
    }
    return product;
  }
}
